import { render, staticRenderFns } from "./AttorneysViewPage.vue?vue&type=template&id=3db9f687"
import script from "./AttorneysViewPage.vue?vue&type=script&lang=js"
export * from "./AttorneysViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports